import { render, staticRenderFns } from "./scgd.vue?vue&type=template&id=7cef8962&scoped=true"
import script from "./scgd.vue?vue&type=script&lang=js"
export * from "./scgd.vue?vue&type=script&lang=js"
import style0 from "./scgd.vue?vue&type=style&index=0&id=7cef8962&prod&lang=scss&scoped=true"
import style1 from "./scgd.vue?vue&type=style&index=1&id=7cef8962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef8962",
  null
  
)

export default component.exports